/**
 * useTicket Hook
 * Fetch single ticket detail
 */

import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-client';
import { TicketDetail } from '@/types';

export function useTicket(ticketId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.tickets.detail(ticketId!),
    queryFn: async () => {
      const { data } = await apiClient.get<TicketDetail>(
        `/tickets/${ticketId}`
      );
      return data;
    },
    enabled: !!ticketId,
  });
}
